import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute  } from "@angular/router";
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl, CheckboxControlValueAccessor, ValidatorFn, ValidationErrors } from '@angular/forms';
import { User} from 'src/app/Model//User/user.model';
//import { UserRole } from 'src/app/Model/Authentication/Role/user-role.model'
import {Location} from '@angular/common';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service';
import { BrowserModule } from '@angular/platform-browser';

@Component({
  selector: 'app-individual-user-fullview',
  templateUrl: './individual-user-fullview.component.html',
  styleUrls: ['./individual-user-fullview.component.scss']
})
export class IndividualUserFullviewComponent implements OnInit {

  branchCategories=[];
  accessCategories=[];
  userSiteAccess=[];
  roleCategories=[];
  
  dbhrcheck=false;
dbhraccess=''
dbinventorycheck=false;
dbinventoryaccess=''
dbhelpdeskcheck=false;
dbhelpdeskaccess='';
dbreportcheck=false;
dbreportaccess=''


  success;
  error;
UsernameFromParent;
UserFirstNameFromParent;
UserLastNameFromParent;

newEmployeeDetailsForm:FormGroup;
  userInfoForm:FormGroup;
  passwordResetForm:FormGroup;
  statusChangeForm:FormGroup;
  roleChangeForm:FormGroup;
  branchChangeForm:FormGroup;
  accessManagementForm:FormGroup;
  expertiseForm:FormGroup;

  perms=true;
  userNameQuery;
  userRole;
  userEmail;
  userBranch;
  userQueryDetails=[];

  currentUser:User;
loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;

expertise;//['Slabs', 'Cut to size', 'Wood', 'Ciot Studio', 'Ceramic and Porcelain Tiles', 'Stone Tiles', 'Installation/Maintenance Product'];

  validationMessages = {
    'password': {
      'required': 'Password Name is required',
      'minlength': 'Password should be atleast 6 characters long'
    },
    'confirmPassword': {
      'required': 'Confirm Password is required',
      'mustMatch': ' Password do not match'
    },

  };


  formErrors = {
    'password': '',
    'confirmPassword': '',
    'minlength':''
    

  };


  constructor(private _authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private router: Router, 
    private actroute: ActivatedRoute,
    private fb: FormBuilder,
    private _appointmentService: AppointmentService,
    private _location: Location,) {

      
      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
      this.loggedInUserFullname=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
      this.loggedInUserBranch=this.currentUser.branch;
      this.loggedInUserId=this.currentUser.userName;

      }
     }

  ngOnInit() {
    this.getBranchCategoriesForForm();
    this.getUserExpertiseForForm();
     //actroute from intangibleasset that passes asset id and name of intangible real estate
     this.actroute.paramMap.subscribe(params => {
      // This is never executed, for route is not recognized
      // let myArray=params.getAll('extra');
      this.userNameQuery=params.get('extra');
      this.userRole=params.get('extra1');
      this.userBranch=params.get('extra2');
      this.userEmail=params.get('extra3');
  //     console.log(this.userNameQuery);
   //    console.log(this.userBranch);
       if(this.userNameQuery){
        this.getUserByID(this.userNameQuery);
     
     
   //   this.getIntangibleAssetToView(assetpid,this.assetname);
//this.viewMode=true;
       }else{
  //      this.viewMode=false;
        console.log('no actrout');
       }
  });





  this.userInfoForm = this.fb.group({
    pid: new FormControl(''),
    userName: new FormControl('', [Validators.required]),
    firstName: new FormControl('', [Validators.required]),
    middleName: new FormControl(''),
    lastName: new FormControl(''),
    status: new FormControl(''),
    branch: new FormControl(''),
  

  });



  this.roleChangeForm = this.fb.group({
    modalMsg: new FormControl(''),
    userName: new FormControl('', [Validators.required]),
    fullName: new FormControl(''),
    firstName: new FormControl(''),
    middleName: new FormControl(''),
    lastName: new FormControl(''),
    email: new FormControl(this.userEmail),
    branch: new FormControl(this.userBranch),
    currentRole: new FormControl(''),
    newRole: new FormControl(''),
    actionPerformedBy: new FormControl(this.loggedInUserId)
  });



  this.expertiseForm = this.fb.group({
    modalMsg: new FormControl(''),
    userName: new FormControl('', [Validators.required]),
    fullName: new FormControl(''),
    firstName: new FormControl(''),
    middleName: new FormControl(''),
    lastName: new FormControl(''),
    email: new FormControl(this.userEmail),
    branch: new FormControl(this.userBranch),
    currentExpertise: this.fb.array([]),
    newExpertise:this.fb.array([]),
    actionPerformedBy: new FormControl(this.loggedInUserId)
  });


  this.passwordResetForm = this.fb.group({
    modalMsg: new FormControl(''),
    userName: new FormControl('', [Validators.required]),
    fullName: new FormControl(''),
    firstName: new FormControl(''),
    middleName: new FormControl(''),
    lastName: new FormControl(''),
    currentStatus: new FormControl(''),
    password: new FormControl('',[Validators.required, Validators.minLength(6)]),
    confirmPassword:new FormControl('',Validators.required),
    actionPerformedBy: new FormControl(this.loggedInUserId)
  },{validator: MustMatch('password','confirmPassword')});




  this.statusChangeForm = this.fb.group({
    modalMsg: new FormControl(''),
    userName: new FormControl('', [Validators.required]),
    fullName: new FormControl(''),
    firstName: new FormControl(''),
    middleName: new FormControl(''),
    lastName: new FormControl(''),
    currentStatus: new FormControl(''),
    newStatus: new FormControl(''),
    actionPerformedBy: new FormControl(this.loggedInUserId)
  });



  this.branchChangeForm = this.fb.group({
    modalMsg: new FormControl(''),
    userName: new FormControl('', [Validators.required]),
    fullName: new FormControl(''),
    firstName: new FormControl(''),
    middleName: new FormControl(''),
    lastName: new FormControl(''),
    currentBranch: new FormControl(''),
    newBranch: new FormControl(''),
    actionPerformedBy: new FormControl(this.loggedInUserId)
  });








    //error handling
    this.passwordResetForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.passwordResetForm);
     })

  }//End of ngOnInit


  backClicked() {
    this._location.back();
  }




  getUserExpertiseForForm() {
    this._appointmentService.getUserExpertiseForForm()
            .subscribe(//subscribe to Observable
              response => {
          //      console.log('Success!', response);
                this.expertise = response;
             
              },
              error => {
                console.error('ERROR!', error);
                this.error = error;
                document.getElementById("openErrorModalButton").click();
              }
            );
      }

      
  getUserExpertiseForFormByLocation(branch) {
   // console.log(branch);
    var locationID="";
    this.branchCategories.forEach(x=>{
     if(x.name==branch){
 locationID=x.locationID;
 
     }
    })
    console.log(locationID)
     this._appointmentService.getUserExpertiseForFormByLocation(locationID)
             .subscribe(//subscribe to Observable
               response => {
                 console.log('Success!', response);
                 this.expertise = response;
              
               },
               error => {
                 console.error('ERROR!', error);
                 this.error = error;
                 document.getElementById("openErrorModalButton").click();
               }
             );
       }
     
     
     
 submitPasswordReset(){
  this.logValidationErrors(this.passwordResetForm);

  this._authenticationService.passwordReset(this.passwordResetForm.value)
        .subscribe(//subscribe to Observable
          response => {
            this.modalService.dismissAll();
           // console.log('Success!', response);
            this.success = response['SUCCESS'];
            this.passwordResetForm.reset;
            document.getElementById("openSuccessModalButton").click();
          },
          error => {
            this.modalService.dismissAll();
            console.error('ERROR!', error);
            this.error = error.error.text;
            document.getElementById("openErrorModalButton").click();
          }
        );
  }




getUserByID(userNameQuery){
  this._authenticationService.getUserByID(userNameQuery)
  .subscribe(
    (userinfo) =>{ 
      console.log(userinfo);
      this.userQueryDetails=userinfo;
    // this.worksheetDetails=this.worksheetinfo;  
    this.UsernameFromParent=Object(this.userQueryDetails[0]).userName;
    this.UserFirstNameFromParent=Object(this.userQueryDetails[0]).firstName;
    this.UserLastNameFromParent=Object(this.userQueryDetails[0]).lastName;
    //this.getEmployeeToView(this.UsernameFromParent,this.UserFirstNameFromParent,this.UserLastNameFromParent);
  //  console.log(Object( this.userQueryDetails[0]).userName);
},
    
(err:any) =>console.log(err)
);

}


/**viewEmployee(employeeformmodel:EmployeeProfile){
  //  console.log(JSON.stringify(employeeformmodel));
        console.log(employeeformmodel);
        
       // const e =Object.assign(employeeformmodel);
        //console.log(array_value(e));
        if(employeeformmodel[0]===null || employeeformmodel[0]===''){
          const removedate=employeeformmodel[0].removalDate;
        }else{
         // const removedate=this.datepipe.transform(assetformmodel[0].removalDate, 'dd/MM/yyyy');
        }
        this.newEmployeeDetailsForm.patchValue({
       //  pid: employeeformmodel[0].pid,
      firstName: employeeformmodel.firstName,
      middleName: employeeformmodel.middleName,
      lastName: employeeformmodel.lastName,
      personalEmail: employeeformmodel.personalEmail,
      address1: employeeformmodel.address1 ,
      city: employeeformmodel.city,
      province: employeeformmodel.province,
      postalCode: employeeformmodel.postal ,
      //purchaseDate: this.datepipe.transform(assetformmodel[0].purchaseDate, 'dd/MM/yyyy'),
      SIN:employeeformmodel.sin,
      dateOfBirth: employeeformmodel.dateOfBirth,
      gender: employeeformmodel.gender ,
      marital: employeeformmodel.marital ,
      title: employeeformmodel.title ,
      manager: employeeformmodel.manager ,
      workEmail: employeeformmodel.workEmail ,
      workPhone: employeeformmodel.workPhone ,
      workExt: employeeformmodel.ext ,
      department: employeeformmodel.department ,
      location: employeeformmodel.location ,
      requisition: employeeformmodel.requisition ,
      dateOfHire: employeeformmodel.dateOfHire ,
      employmentType: employeeformmodel.employmentType ,
      contractEndDate: employeeformmodel.contractEndDate 
  
        });
  
  }

  onSelect(destRoute,userName){
    this.router.navigate([destRoute,{extra:userName}],{relativeTo: this.actroute});

  }**/


/**getEmployeeToView(employeeid,employeeFirstname,employeeLastname){
  this._employeeService.getSingleEmployee(employeeid,employeeFirstname,employeeLastname).subscribe(
    (employeeview:EmployeeProfile) => {
      console.log(employeeview);
      if(employeeview.title!=null){
      this.viewEmployee(employeeview);
    this.employeeviewmodel=employeeview;
    console.log(this.employeeviewmodel.firstName);}
   // var today:any=formatDate(new Date().getTime(),'dd-MM-yyyy','en');
    //var start:any=formatDate(new Date(this.assetviewmodel[0].startDate).getTime(),'dd-MM-yyyy','en');
   
    },
    
    (err:any) =>console.log(err)
  );


}**/

editUser(user){
 // console.log(user.pid);
    this.router.navigate(['../user-edit', { extra: user.pid, extra1: user.userName }], { relativeTo: this.actroute });
}

logValidationErrors(group: FormGroup ): void {
  //get the keys from FormGroup object and checks all the keys
  Object.keys(group.controls).forEach((key: string) => {
    const abstractControl = group.get(key);
    //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
    if (abstractControl instanceof FormGroup) {
      this.logValidationErrors(abstractControl);
    } else {
      //clear any previous error
      this.formErrors[key] = '';
      //check Validation of the formControl
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        //if not valid then get the error message of whatever the validation error is from the validationMessage method
        const messages = this.validationMessages[key];
        //for every error in validation get the error key and assign it to the formControl name is formError method
        for (const errorkey in abstractControl.errors) {
          if (errorkey) {
            console.log(key);
         

            this.formErrors[key] += messages[errorkey] + ''
          }
        }
      }
    }

  });
}



getRoleCategoriesForForm(){
  this._authenticationService.getRoleCategoriesForForm().subscribe(
    (res) => {

      this.roleCategories = res;
     // console.log(this.roleCategories);
    },
    (err) => {
      this.error = err;
    }
  );
}

/********************************************************************** */


openRoleModal(userQueryDetails,modal){
 
  this.getRoleCategoriesForForm();
      var finalmessage= "Please select the Role you wish to change to: "
    
  
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static'
    });
  
    this.roleChangeForm.patchValue({
      modalMsg: finalmessage,
      userName: userQueryDetails.userName,
      fullName:userQueryDetails.firstName+' '+userQueryDetails.middleName+' '+userQueryDetails.lastName,
      firstName: userQueryDetails.firstName,
      middleName: userQueryDetails.middleName,
      lastName:userQueryDetails.lastName,
      currentRole: userQueryDetails.role,    
      
     });
  
   
  
     
  
     console.log(this.roleChangeForm.value);
    
  }



/********************************************************************** */


openExpertiseModal(userQueryDetails,modal){
// console.log(userQueryDetails)
  this.getUserExpertiseForFormByLocation(userQueryDetails.branch);
      var finalmessage= "Please select the Expertise you wish to change to: "
    
  
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static'
    });
    const newExpertise = this.expertiseForm.get('newExpertise') as FormArray;
    const currentExpertise = this.expertiseForm.get('currentExpertise') as FormArray;
var dbexpertise= userQueryDetails.expertise;
//console.log(dbexpertise)
    dbexpertise.forEach(e => {
   
    newExpertise.push(this.fb.control(e));
    currentExpertise.push(this.fb.control(e));
    });

    
  
    this.expertiseForm.patchValue({
      modalMsg: finalmessage,
      userName: userQueryDetails.userName,
      fullName:userQueryDetails.firstName+' '+userQueryDetails.middleName+' '+userQueryDetails.lastName,
      firstName: userQueryDetails.firstName,
      middleName: userQueryDetails.middleName,
      lastName:userQueryDetails.lastName,
      //currentExpertise: userQueryDetails.expertise, 
      //newExpertise: userQueryDetails.expertise,    
      
     });
  
   
  
     
  
   //  console.log(this.expertiseForm.value);
    
  }
/*************************************************************************** */  

openPasswordResetModal(userQueryDetails,modal){
  //console.log(userQueryDetails);
  
  if(userQueryDetails.status=="Active"){
    var finalmessage= "Are you sure you want to change Password?"
    var newStatus="Completed";

  } else if(userQueryDetails.status=="InActive"){
    var finalmessage= "Are you sure you want to change password as the user is not Active?"
    var newStatus="Incomplete";
  }

  this.modalService.open(modal, {
    centered: true,
    backdrop: 'static'
  });

  this.passwordResetForm.patchValue({
    modalMsg: finalmessage,
    userName: userQueryDetails.userName,
    fullName:userQueryDetails.firstName+' '+userQueryDetails.middleName+' '+userQueryDetails.lastName,
    firstName: userQueryDetails.firstName,
    middleName: userQueryDetails.middleName,
    lastName:userQueryDetails.lastName,
    currentStatus: userQueryDetails.status,    
   });

   

 //  console.log(this.passwordResetForm.value);
}



openStatusChangetModal(userQueryDetails,modal){
 
  if(userQueryDetails.status=="Active"){
    var finalmessage= "Are you sure you want to deactivate this user?"
    var newStatus="InActive";

  } else if(userQueryDetails.status=="InActive" || userQueryDetails.status==""){
    var finalmessage= "Are you sure you want to activate this user?"
    var newStatus="Active";
  }

  this.modalService.open(modal, {
    centered: true,
    backdrop: 'static'
  });

  this.statusChangeForm.patchValue({
    modalMsg: finalmessage,
    userName: userQueryDetails.userName,
    fullName:userQueryDetails.firstName+' '+userQueryDetails.middleName+' '+userQueryDetails.lastName,
    firstName: userQueryDetails.firstName,
    middleName: userQueryDetails.middleName,
    lastName:userQueryDetails.lastName,
    currentStatus: userQueryDetails.status,    
    newStatus: newStatus
   });

   

   console.log(this.statusChangeForm.value);
  
}





openBranchModal(userQueryDetails,modal){
 
this.getBranchCategoriesForForm();
    var finalmessage= "Please select the Branch you wish to change to: "
  

  this.modalService.open(modal, {
    centered: true,
    backdrop: 'static'
  });

  this.branchChangeForm.patchValue({
    modalMsg: finalmessage,
    userName: userQueryDetails.userName,
    fullName:userQueryDetails.firstName+' '+userQueryDetails.middleName+' '+userQueryDetails.lastName,
    firstName: userQueryDetails.firstName,
    middleName: userQueryDetails.middleName,
    lastName:userQueryDetails.lastName,
    currentBranch: userQueryDetails.branch,    
    
   });

 

   

   console.log(this.branchChangeForm.value);
  
}



getAccessCategoriesForForm(){
  this._authenticationService.getAccessCategoriesForForm().subscribe(
    (res) => {

      this.accessCategories = res;
   //   console.log(this.accessCategories);
    },
    (err) => {
      this.error = err;
    }
  );
}




getBranchCategoriesForForm(){
  this._authenticationService.getBranchCategoriesForForm().subscribe(
    (res) => {

      this.branchCategories = res;
   //   console.log(this.branchCategories);
    },
    (err) => {
      this.error = err;
    }
  );
}



saveIndividualExpertise(){
  this.logValidationErrors(this.roleChangeForm);

  this._authenticationService.individualExpertiseChange(this.expertiseForm.value)
        .subscribe(//subscribe to Observable
          response => {
            this.modalService.dismissAll();
            console.log('Success!', response);
            this.success = response['SUCCESS'];
            this.expertiseForm.reset;
            document.getElementById("openIndividualSuccessModalButton").click();
          },
          error => {
            this.modalService.dismissAll();
            console.log(error);
            console.error('ERROR!', error);
            this.error = error.error.text;
            document.getElementById("openErrorModalButton").click();
          }
        );
}

/*****************************************************************8 */
saveIndividualRole(){
  this.logValidationErrors(this.roleChangeForm);

  this._authenticationService.individualRoleChange(this.roleChangeForm.value)
        .subscribe(//subscribe to Observable
          response => {
            this.modalService.dismissAll();
            console.log('Success!', response);
            this.success = response['SUCCESS'];
            this.passwordResetForm.reset;
            document.getElementById("openIndividualSuccessModalButton").click();
          },
          error => {
            this.modalService.dismissAll();
            console.error('ERROR!', error);
            this.error = error.error.text;
            document.getElementById("openErrorModalButton").click();
          }
        );
}

/*****************************************************************8 */

saveIndividualStatus(){
  this.logValidationErrors(this.statusChangeForm);

  this._authenticationService.individualStatusChange(this.statusChangeForm.value)
        .subscribe(//subscribe to Observable
          response => {
            this.modalService.dismissAll();
            console.log('Success!', response);
            this.success = response['SUCCESS'];
            this.passwordResetForm.reset;
            document.getElementById("openIndividualSuccessModalButton").click();
          },
          error => {
            this.modalService.dismissAll();
            console.error('ERROR!', error);
            this.error = error.error.text;
            document.getElementById("openErrorModalButton").click();
          }
        );
}


saveIndividualBranch(){
  this.logValidationErrors(this.branchChangeForm);

  this._authenticationService.individualBranchChange(this.branchChangeForm.value)
        .subscribe(//subscribe to Observable
          response => {
            this.modalService.dismissAll();
            console.log('Success!', response);
            this.success = response['SUCCESS'];
            this.passwordResetForm.reset;
            document.getElementById("openIndividualSuccessModalButton").click();
          },
          error => {
            this.modalService.dismissAll();
            console.error('ERROR!', error);
            this.error = error.error.text;
            document.getElementById("openErrorModalButton").click();
          }
        );
}

refresh(): void {
  window.location.reload();
}

/**
saveIndividualSiteAccess(){
  this.logValidationErrors(this.accessManagementForm);

  this._authenticationService.individualSiteAccessUpdate(this.accessManagementForm.value)
        .subscribe(//subscribe to Observable
          response => {
            this.modalService.dismissAll();
            console.log('Success!', response);
            this.success = response['SUCCESS'];
            this.passwordResetForm.reset;
            document.getElementById("openSuccessModalButton").click();
          },
          error => {
            this.modalService.dismissAll();
            console.error('ERROR!', error);
            this.error = error.error.text;
            document.getElementById("openErrorModalButton").click();
          }
        );
}

isAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.Administrator;
}

  isSystemAdmin() {
return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
}

**/



changeFormControlValue(event,evt,controlname){
  const val= evt;
  //this.newEmployeeDetailsForm.get('newDeskSetup');
 // console.log(val);
  if(evt===false){
event.srcElement.checked=false;
 // this.newEmployeeDetailsForm.get(controlname).setValue('false'); 
 
  } else  if(evt===true){
   
    this.accessManagementForm.get(controlname).setValue(true); 
  // this.validateIfChecked();
    }
}





onExpertiseChange(expert, event: any) {
 // console.log(expert);
  const expertise = this.expertiseForm.get('newExpertise') as FormArray;
  if (event.target.checked) {
    expertise.push(this.fb.control(expert));
  } else {
    const index = expertise.controls.findIndex(x => x.value === expert);
    expertise.removeAt(index);
  }
  console.log(expertise.value);
}

validateIfChecked(): ValidatorFn {
  return (form: FormGroup): ValidationErrors | null => {
    const hrcheckfield = form.get('HRCheck').value;
    const hraccessfield= form.get('HRAccess').value;
    const inventorycheckfield = form.get('inventoryCheck').value;
    const inventoryaccessfield= form.get('inventoryAccess').value;
    const helpdeskcheckfield = form.get('helpdeskCheck').value;
    const helpdeskaccessfield= form.get('helpdeskAccess').value;
    const reportcheckfield = form.get('reportCheck').value;
    const reportaccessfield= form.get('reportAccess').value;
   
    if ((hrcheckfield && hraccessfield=='') || (inventorycheckfield && inventoryaccessfield=='') || (helpdeskcheckfield && helpdeskaccessfield=='') || (reportcheckfield && reportaccessfield=='')){
  
      return {
        'err': true
      };

    }
    return null;
  }
}


}




function PasswordValidator(control: AbstractControl):{[key:string]:boolean }|null{

  //control refers to the form-group and not a specific form-control
  const password = control.get('password');
  const confirmPassword = control.get('confirmPassword');
  if(password.pristine || confirmPassword.pristine){
  return null;
  }
  return password && confirmPassword && password.value != confirmPassword.value ?
  {'Mismatch':true} : null;
  }

  
  function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}